import { styled } from "@mui/material";
import { Drawer as MuiDrawer } from '@mui/material';

const drawerWidth = 255;
export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'mobile' })(
  ({ theme, open, mobile }) => ({
    '& .MuiDrawer-paper': {
      position: mobile ? 'fixed' : 'relative',
      whiteSpace: 'nowrap',
      width: mobile ? 'min(82vw, 280px)' : drawerWidth,
      border: "none",
      backgroundColor: `#FAFAFB`,
      index:1,
      zIndex: mobile ? theme.zIndex.drawer + 2 : 2,
      margin: "none",
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      ...(!mobile && !open && {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('xs')]: {
          width: theme.spacing(9)
        },
      }),
    },
  }),
);
